/** Prints one part of the app; see styles/print.css. */
export function printSection(section: 'run-sheet' | 'tech-report') {
  document.body.dataset.print = section;
  const clear = () => { delete document.body.dataset.print; window.removeEventListener('afterprint', clear); };
  window.addEventListener('afterprint', clear);
  window.print();
}
